import React from 'react';
import { ReactComponent as CheckIcon } from 'assets/icons/check.svg';
import clsx from 'clsx';

import type IAICardPanelSearchDropdownProps from '../interfaces/IAICardPanelSearchDropdownProps';

import styles from '../sass/AICardPanel.module.scss';

function AICardPanelSearchDropdown({
  items,
  selectedNodeIds,
  onToggle,
}: IAICardPanelSearchDropdownProps) {
  if (!items.length) {
    return null;
  }

  return (
    <ul className={styles.searchDropdown} role="listbox" aria-label="Search results">
      {items.map((card) => {
        const isSelected = selectedNodeIds.has(card.nodeId);

        return (
          <li
            key={card.nodeId}
            role="option"
            aria-selected={isSelected}
            className={clsx(styles.searchDropdownItem, {
              [styles.searchDropdownItemSelected]: isSelected,
            })}
            tabIndex={0}
            onClick={() => onToggle(card.nodeId)}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                onToggle(card.nodeId);
              }
            }}
          >
            <span className={styles.searchDropdownItemName}>
              {card.name}
            </span>
            {isSelected ? (
              <span className={styles.searchDropdownItemCheck} aria-hidden="true">
                <CheckIcon />
              </span>
            ) : null}
          </li>
        );
      })}
    </ul>
  );
}

export default AICardPanelSearchDropdown;
